import { createAsyncThunk } from '@reduxjs/toolkit';

import * as AuthService from 'Services/AuthService';

export const guestUserSignup = createAsyncThunk('guestAuth/fetch', async () => {
  const response = await AuthService.postGuestUserSignup();
  return response;
});
